"use client";
import { jsx as a } from "react/jsx-runtime";
import { memo as h } from "react";
import o from "../components/Icon/SvgIcon.js";
const e = (v) => /* @__PURE__ */ a(
  o,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...v,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.251 8.132H20.75V6.265c0-.902-.73-1.636-1.625-1.636H17.8v1a.876.876 0 0 1-1.752 0v-1h-8.26v1a.876.876 0 0 1-1.752 0v-1H4.877c-.897 0-1.626.734-1.626 1.636zm15.873 12.013c.895 0 1.625-.732 1.625-1.635V9.383H3.251v9.127c0 .903.73 1.635 1.626 1.635zM17.8 3.377h1.325a2.885 2.885 0 0 1 2.877 2.888V18.51a2.885 2.885 0 0 1-2.877 2.887H4.877A2.885 2.885 0 0 1 2 18.51V6.265a2.885 2.885 0 0 1 2.877-2.888h1.16v-.501a.876.876 0 1 1 1.751 0v.501h8.26v-.501a.876.876 0 1 1 1.751 0zM7.621 13.887H6.369a1 1 0 0 1-1-1v-1.252a1 1 0 0 1 1-1h1.252a1 1 0 0 1 1 1v1.252a1 1 0 0 1-1 1m5.005 0h-1.251a1 1 0 0 1-1.001-1v-1.252a1 1 0 0 1 1-1h1.252a1 1 0 0 1 1.001 1v1.252a1 1 0 0 1-1 1m3.754 0h1.252a1 1 0 0 0 1-1v-1.252a1 1 0 0 0-1-1H16.38a1 1 0 0 0-1 1v1.252a1 1 0 0 0 1 1m-8.76 5.006H6.37a1 1 0 0 1-1.002-1V16.64a1 1 0 0 1 1.002-1h1.252a1 1 0 0 1 1 1v1.252a1 1 0 0 1-1 1.001m3.755 0h1.251a1 1 0 0 0 1.001-1V16.64a1 1 0 0 0-1-1.001h-1.252a1 1 0 0 0-1.001 1v1.252a1 1 0 0 0 1 1.001m6.256 0h-1.25a1 1 0 0 1-1.002-1V16.64a1 1 0 0 1 1.001-1.001h1.252a1 1 0 0 1 1 1v1.252a1 1 0 0 1-1 1.001",
        clipRule: "evenodd"
      }
    )
  }
), t = h(e);
export {
  t as Calendar,
  t as default
};
